/**
* @prop --uic-header-menu-bg-color-hover: background color when hovered
* @prop --uic-header-menu-text-color: default text and icon color
* @prop --uic-header-menu-text-color-active: text and icon color when the item is active
* @prop --uic-header-menu-text-color-focus: text and icon color when the item has focus
* @prop --uic-header-menu-text-color-selected: text and icon color when the item is selected
* @prop --uic-header-menu-text-color-disabled: text and icon color when the item is disabled
* @prop --uic-header-menu-border-color: outline color
* @prop --uic-header-menu-border-color-focus: outline color when the item has focus
* @prop --uic-header-menu-border-style: outline style
* @prop --uic-header-menu-border-width: outline thickness
*/
uic-header-menu-item {
  color: var(--uic-header-menu-text-color);
  display: block;
  flex: 0 0 auto;
  font-size: var(--uic-font-size-normal);
  font-weight: var(--uic-font-weight-bold);
  height: var(--uic-header-height);
  line-height: var(--uic-line-height-normal);
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: relative;
  user-select: none;

  .uic-header-menu--vertical &,
  .uic-header-menu-item__submenu & {
    flex: 1 0 auto;
  }

  @media #{$breakpoint_smartphone} {
    min-width: 48px;
  }

  .uic-header-menu-item__label {
    display: inline-block;
    flex: 1 0 auto;
  }

  .uic-header-menu-item__label + uic-icon {
    margin-left: 8px;
  }

  uic-icon ~ .uic-header-menu-item__label {
    margin-left: 8px;
  }

  uic-icon {
    flex: 0 0 auto;
  }

  uic-badge {
    left: 5px;
    position: absolute;
    top: 5px;
  }

  &:not([disabled]) {
    cursor: pointer;
  }

  &[disabled] {
    color: var(--uic-header-menu-text-color-disabled);
    pointer-events: none;
  }

  &[selected] > .uic-header-menu-item__item {
    color: var(--uic-header-menu-text-color-selected);
  }

  &:focus {
    outline-color: var(--uic-header-text-color-active);
  }

  &:focus > .uic-header-menu-item__item {
    color: var(--uic-header-menu-text-color-focus);
  }

  &:active > .uic-header-menu-item__item {
    color: var(--uic-header-menu-text-color-active);
  }

  .uic-header-menu-item__item {
    align-items: center;
    box-sizing: border-box;
    color: inherit;
    display: flex;
    flex: 0 0 auto;
    height: var(--uic-header-height);
    justify-content: center;
    min-width: 64px;
    padding: 0 20px 0 14px;
    position: relative;
    text-decoration: none;

    &:hover {
      background-color: var(--uic-header-menu-bg-color-hover);
    }

    .uic-header-menu--vertical &,
    .uic-header-menu-item__submenu & {
      flex: 1 0 auto;
      justify-content: stretch;
    }
  }

  .uic-header-menu-item__submenu {
    background-color: var(--uic-header-bg-color-secondary);
    display: none;
    left: 0;
    position: absolute;
    top: 100%;
    width: 240px;

    &--expanded {
      display: block;
    }

    &--vertical {
      left: 100%;
      top: 0;
    }
  }
}

.uic-header-menu-item--icon-only {
  .uic-header-menu-item__item {
    padding: 0 14px;
  }

  .uic-header-menu-item__label {
    display: none;
  }
}
